import { Stack, Typography } from '@mui/material';
import { ReactElement } from 'react';

export interface IconLabelProps {
  children: string;
  icon?: ReactElement;
}

export function IconLabel({ children, icon = undefined }: IconLabelProps) {
  return (
    <Stack direction="row" spacing={2} className="ml-2 flex h-12 min-h-12 items-center py-4">
      {icon}
      <Typography sx={{ fontSize: '14px' }}>{children}</Typography>
    </Stack>
  );
}
